import {
  Settings,
  SettingType,
  SettingCategory,
  SettingOption,
  ValidationRule,
  ValidationRuleType,
} from '../models/settings.model';

export const MOCK_SETTINGS: Settings[] = [
  {
    id: 1,
    key: 'app.name',
    value: 'Sunset Gardens Management System',
    valueKey: 'settings.sunset-gardens-management-system',
    type: SettingType.STRING,
    category: SettingCategory.GENERAL,
    description: 'Application display name',
    descriptionKey: 'settings.application-display-name-description',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    validationRules: [
      {
        id: 1,
        settingId: 1,
        ruleType: ValidationRuleType.REQUIRED,
        value: true,
        message: 'Application name is required',
        isActive: true,
      },
      {
        id: 2,
        settingId: 1,
        ruleType: ValidationRuleType.MIN_LENGTH,
        value: 3,
        message: 'Application name must be at least 3 characters',
        isActive: true,
      },
    ],
    defaultValue: 'Property Management System',
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 2,
    key: 'app.version',
    value: '2.1.0',
    valueKey: 'settings.version-2-1-0',
    type: SettingType.STRING,
    category: SettingCategory.GENERAL,
    description: 'Application version number',
    descriptionKey: 'settings.application-version-description',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: true,
    defaultValue: '1.0.0',
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 3,
    key: 'app.timezone',
    value: 'America/New_York',
    type: SettingType.STRING,
    category: SettingCategory.GENERAL,
    description: 'Default timezone for the application',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    options: [
      {
        id: 1,
        settingId: 3,
        label: 'Eastern Time (ET)',
        value: 'America/New_York',
        description: 'Eastern Standard Time',
        isDefault: true,
        isActive: true,
        sortOrder: 1,
      },
      {
        id: 2,
        settingId: 3,
        label: 'Central Time (CT)',
        value: 'America/Chicago',
        description: 'Central Standard Time',
        isDefault: false,
        isActive: true,
        sortOrder: 2,
      },
      {
        id: 3,
        settingId: 3,
        label: 'Mountain Time (MT)',
        value: 'America/Denver',
        description: 'Mountain Standard Time',
        isDefault: false,
        isActive: true,
        sortOrder: 3,
      },
      {
        id: 4,
        settingId: 3,
        label: 'Pacific Time (PT)',
        value: 'America/Los_Angeles',
        description: 'Pacific Standard Time',
        isDefault: false,
        isActive: true,
        sortOrder: 4,
      },
    ],
    defaultValue: 'America/New_York',
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 4,
    key: 'app.currency',
    value: 'USD',
    type: SettingType.STRING,
    category: SettingCategory.GENERAL,
    description: 'Default currency for the application',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    options: [
      {
        id: 5,
        settingId: 4,
        label: 'US Dollar',
        value: 'USD',
        description: 'United States Dollar',
        isDefault: true,
        isActive: true,
        sortOrder: 1,
      },
      {
        id: 6,
        settingId: 4,
        label: 'Canadian Dollar',
        value: 'CAD',
        description: 'Canadian Dollar',
        isDefault: false,
        isActive: true,
        sortOrder: 2,
      },
      {
        id: 7,
        settingId: 4,
        label: 'Euro',
        value: 'EUR',
        description: 'Euro',
        isDefault: false,
        isActive: true,
        sortOrder: 3,
      },
    ],
    defaultValue: 'USD',
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 5,
    key: 'security.two_factor_required',
    value: true,
    type: SettingType.BOOLEAN,
    category: SettingCategory.SECURITY,
    description: 'Require two-factor authentication for all users',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    defaultValue: false,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 6,
    key: 'security.session_timeout',
    value: 30,
    type: SettingType.NUMBER,
    category: SettingCategory.SECURITY,
    description: 'Session timeout in minutes',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    validationRules: [
      {
        id: 3,
        settingId: 6,
        ruleType: ValidationRuleType.MIN_VALUE,
        value: 5,
        message: 'Session timeout must be at least 5 minutes',
        isActive: true,
      },
      {
        id: 4,
        settingId: 6,
        ruleType: ValidationRuleType.MAX_VALUE,
        value: 480,
        message: 'Session timeout must not exceed 8 hours',
        isActive: true,
      },
    ],
    defaultValue: 30,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 7,
    key: 'notifications.email_enabled',
    value: true,
    type: SettingType.BOOLEAN,
    category: SettingCategory.NOTIFICATIONS,
    description: 'Enable email notifications',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    defaultValue: true,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 8,
    key: 'notifications.sms_enabled',
    value: false,
    type: SettingType.BOOLEAN,
    category: SettingCategory.NOTIFICATIONS,
    description: 'Enable SMS notifications',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    defaultValue: false,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 9,
    key: 'email.smtp_host',
    value: 'smtp.gmail.com',
    type: SettingType.STRING,
    category: SettingCategory.EMAIL,
    description: 'SMTP server hostname',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    validationRules: [
      {
        id: 5,
        settingId: 9,
        ruleType: ValidationRuleType.REQUIRED,
        value: true,
        message: 'SMTP host is required',
        isActive: true,
      },
    ],
    defaultValue: 'localhost',
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 10,
    key: 'email.smtp_port',
    value: 587,
    type: SettingType.NUMBER,
    category: SettingCategory.EMAIL,
    description: 'SMTP server port',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    validationRules: [
      {
        id: 6,
        settingId: 10,
        ruleType: ValidationRuleType.MIN_VALUE,
        value: 1,
        message: 'Port must be at least 1',
        isActive: true,
      },
      {
        id: 7,
        settingId: 10,
        ruleType: ValidationRuleType.MAX_VALUE,
        value: 65535,
        message: 'Port must not exceed 65535',
        isActive: true,
      },
    ],
    defaultValue: 25,
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 11,
    key: 'email.smtp_password',
    value: 'encrypted_password_here',
    type: SettingType.PASSWORD,
    category: SettingCategory.EMAIL,
    description: 'SMTP server password',
    isSystemSetting: true,
    isEncrypted: true,
    isReadOnly: false,
    defaultValue: '',
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 12,
    key: 'ui.theme',
    value: 'light',
    type: SettingType.STRING,
    category: SettingCategory.UI,
    description: 'Default UI theme',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    options: [
      {
        id: 8,
        settingId: 12,
        label: 'Light Theme',
        value: 'light',
        description: 'Light color scheme',
        isDefault: true,
        isActive: true,
        sortOrder: 1,
      },
      {
        id: 9,
        settingId: 12,
        label: 'Dark Theme',
        value: 'dark',
        description: 'Dark color scheme',
        isDefault: false,
        isActive: true,
        sortOrder: 2,
      },
      {
        id: 10,
        settingId: 12,
        label: 'Auto Theme',
        value: 'auto',
        description: 'Automatically switch based on system preference',
        isDefault: false,
        isActive: true,
        sortOrder: 3,
      },
    ],
    defaultValue: 'light',
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
  {
    id: 13,
    key: 'business.maintenance_hours',
    value: {
      monday: { start: '08:00', end: '17:00' },
      tuesday: { start: '08:00', end: '17:00' },
      wednesday: { start: '08:00', end: '17:00' },
      thursday: { start: '08:00', end: '17:00' },
      friday: { start: '08:00', end: '17:00' },
      saturday: { start: '09:00', end: '15:00' },
      sunday: { start: '10:00', end: '14:00' },
    },
    type: SettingType.JSON,
    category: SettingCategory.BUSINESS,
    description: 'Maintenance team working hours',
    isSystemSetting: true,
    isEncrypted: false,
    isReadOnly: false,
    defaultValue: {},
    createdDate: new Date('2020-01-15T00:00:00Z'),
    updatedDate: new Date('2024-01-10T14:30:00Z'),
    updatedBy: 1,
  },
];
